module.exports = __webpack_public_path__ + "static/media/icon_edit.73e20f53.svg";